'use strict';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.leftPadToBytes32 = exports.validBytes32OrError = exports.validAddressOrError = exports.validNumberOrDefault = exports.isFunction = exports.isUndefined = exports.isNull = exports.isObject = exports.isArray = exports.toInteger = exports.newNonce = exports.isHex = exports.sanitizeHex = exports.toPrefixedHex = exports.calcIntrinsicGas = void 0;
const params_1 = require("./params");
__exportStar(require("./params"), exports);
__exportStar(require("./option-formatters"), exports);
exports.calcIntrinsicGas = function (tx) {
    let totalGas = params_1.params.TxGas;
    // calculate data gas
    if (tx.data) {
        const buffer = Buffer.from(exports.sanitizeHex(tx.data), 'hex');
        let z = 0;
        let nz = 0;
        for (const byte of buffer) {
            if (byte) {
                nz++;
            }
            else {
                z++;
            }
        }
        totalGas += params_1.params.TxDataZeroGas * z;
        totalGas += params_1.params.TxDataNonZeroGas * nz;
    }
    if (!!tx.to) {
        totalGas += params_1.params.ClauseGas;
    }
    else {
        totalGas += params_1.params.ClauseGasContractCreation;
    }
    return totalGas;
};
exports.toPrefixedHex = function (hexStr) {
    if (hexStr.indexOf('0x') === 0) {
        return hexStr;
    }
    else {
        return '0x' + hexStr;
    }
};
exports.sanitizeHex = function (hexStr) {
    if (hexStr.indexOf('0x') === 0) {
        return hexStr.substr(2);
    }
    else {
        return hexStr;
    }
};
exports.isHex = function (hex) {
    return !!hex && ((typeof hex === 'string') && /^(-0x|0x)?[0-9a-f]+$/i.test(hex));
};
exports.newNonce = function () {
    return Math.floor((new Date().getTime() / 0xffff) * Math.random() * 0xffff);
};
exports.toInteger = function (input) {
    const num = Number.parseInt(input);
    if (Number.isInteger(num)) {
        return num;
    }
    else {
        return null;
    }
};
exports.isArray = function (o) {
    return Object.prototype.toString.call(o) === '[object Array]';
};
exports.isObject = function (o) {
    return Object.prototype.toString.call(o) === '[object Object]';
};
exports.isNull = function (o) {
    return Object.prototype.toString.call(o) === '[object Null]';
};
exports.isUndefined = function (o) {
    return Object.prototype.toString.call(o) === '[object Undefined]';
};
exports.isFunction = function (o) {
    return typeof o === 'function';
};
exports.validNumberOrDefault = function (value, defaultValue) {
    if (typeof value === 'number' && Number.isInteger(value)) {
        return Math.abs(value);
    }
    if (Number.isNaN(Number.parseInt(value)) === false) {
        return Math.abs(Number.parseInt(value));
    }
    return defaultValue;
};
exports.validAddressOrError = function (input, msg = 'Invalid address string') {
    if (/^(-0x|0x)?[0-9a-fA-F]{40}$/i.test(input)) {
        return exports.toPrefixedHex(input);
    }
    else {
        throw new Error(msg);
    }
};
exports.validBytes32OrError = function (input, msg = 'Invalid hex string') {
    if (/^(-0x|0x)?[0-9a-fA-F]{64}$/i.test(input)) {
        return exports.toPrefixedHex(input);
    }
    else {
        throw new Error(msg);
    }
};
exports.leftPadToBytes32 = function (input) {
    return ('0x' + '0'.repeat(64 - exports.sanitizeHex(input).length) + exports.sanitizeHex(input));
};
//# sourceMappingURL=data:application/json;base64,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